import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: [],
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.REMINDER_DATES_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.REMINDER_DATES_SUCCESS: {
      const result =
        action.response.data &&
        action.response.data.map((item) => {
          return {
            value: item.key,
            text: item.displayValue,
          };
        });
      return {
        ...state,
        data: result || [],
        isProgress: false,
      };
    }
    case homeConstants.REMINDER_DATES_FAILURE:
      return {
        data: [],
        error: action.error,
        isProgress: false,
      };
    default:
      return state;
  }
}
